import React from 'react';
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { PolarArea } from 'react-chartjs-2';
import GenericTitleP from '../../titles/GenericTitleP'

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

export const data = {
  labels: ['Category 0', 'Category 1', 'Category 2', 'Category 3', 'Category 4', 'Category 5', 'Category 6'],
  datasets: [
    {
      label: '# of Votes',
      data: [122, 458, 312, 571, 223, 96],
      backgroundColor: [
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
        'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)',
        'rgba(153, 102, 255, 0.5)',
        'rgba(255, 159, 64, 0.5)',
      ],
      borderWidth: 1,
    },
  ],
};

const PolarAreaChart = () => {
  return <div className="p-md-4 p-2 m-4 rounded shadow">
      <GenericTitleP>Sales According to Category</GenericTitleP>
      <div className='w-100 p-3'></div>
      <PolarArea className='mt-4 h-100' data={data} />
    
    </div>
}

export default PolarAreaChart